cockpitApp.directive('documents', function () {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: '/element/detail/documents',
    controllerAs: 'documentsCtrl',
    controller: 'documentsController'
  };
});
